import React from "react";
import usePageMeta from "../../utils/usePageMeta";
import Section1 from "../../components/Section1";
import Section2 from "../../components/Section2";
import ExperienceSection from "../../components/ExperienceSection";
import Section3 from "../../components/Section3";
import Section4 from "../../components/Section4";
import Section10 from "../../components/Section10";
import TestimonialsSection from "../../components/TestimonialsSection";

const HomePage = () => {
  usePageMeta({
    title: "Software Consultancy for Web, Mobile & Desktop",
    description:
      "Hamza Mehboob leads a senior team that designs, builds and ships web, mobile and desktop products end to end: Flutter apps, React and Next.js web apps, admin dashboards and Node.js APIs. 30 five-star client reviews.",
    path: "/",
  });
  return (
    <>
      <Section1 />
      <Section2 />
      <ExperienceSection />
      {/* Three featured case studies; the full grid lives on /portfolio. */}
      <Section3 featuredOnly />
      <Section4 />
      <TestimonialsSection />
      <Section10 />
    </>
  );
};

export default HomePage;
